<template>
  <BaseControlBar>
  <!-- <BaseControlBar :back-url="backUrl"> -->
    <div class="flex-grow-1 d-flex">
      <h1>{{ title }}&nbsp;</h1>
      <StatusLabel v-if="currentStatus" :item="status"></StatusLabel>
    </div>
    <template v-if="$route.name === 'AddCoupon' || $route.name === 'AddPaymentCoupon'">
      <BaseButton
        @click="$router.push(backUrl)"
        variant="outline-secondary"
        class="app--mobile-hidden"
        >取消</BaseButton
      >
      <BaseButton
        @click="$emit('save-draft-click')"
        variant="outline-secondary"
        class="app--mobile-hidden"
      >
        儲存草稿
      </BaseButton>
      <ButtonPreview @click="$emit('preview-click')" :isShowIcon="false" class="app--mobile-hidden">
        預覽及提交
      </ButtonPreview>
    </template>
    <template v-else>
      <template v-if="isPermit('EDIT')">
        <template v-if="readOnly">
          <ButtonEdit @click="onEdit" class="app--mobile-hidden">編輯</ButtonEdit>
        </template>
        <template v-else class="app--mobile-hidden">
          <BaseButton variant="outline-secondary" @click="onCancel" class="app--mobile-hidden"
            >取消</BaseButton
          >
          <ButtonRemove
            v-if="isPermit('REMOVE')"
            @click="prepareAction('REMOVE')"
            variant="outline-secondary"
            class="app--mobile-hidden"
          >
            移除草稿
          </ButtonRemove>
          <BaseButton
            v-if="isPermit('SAVE')"
            @click="$emit('save-draft-click')"
            variant="outline-secondary"
            class="app--mobile-hidden"
          >
            儲存草稿
          </BaseButton>
          <ButtonPreview
            @click="$emit('preview-click')"
            :isShowIcon="false"
            class="app--mobile-hidden"
          >
            預覽及提交
          </ButtonPreview>
        </template>
      </template>
      <template v-else class="app--mobile-hidden">
        <ButtonUnpublish
          v-if="isPermit('STOPPED')"
          @click="prepareAction('UNPUBLISH', '你已暫停發佈這個優惠')"
          class="app--mobile-hidden"
        >
          暫停發佈
        </ButtonUnpublish>
        <ButtonRedemptionStatus
          v-if="isPermit('REDEMPTION_STATUS')"
          @click="stocksModal = true"
          class="app--mobile-hidden"
        >
          兌換情況
        </ButtonRedemptionStatus>
        <BaseButton
          v-if="isPermit('CANCEL')"
          @click="prepareAction('CANCEL')"
          variant="outline-secondary"
          class="app--mobile-hidden"
        >
          取消提交
        </BaseButton>
        <ButtonPreview
          v-if="readOnly"
          @click="$bvModal.show('coupon-preview-modal')"
          class="app--mobile-hidden"
        >
          預覽
        </ButtonPreview>
      </template>
    </template>
    <template v-slot:secondRow>
      <!-- button-for-mobile start -->
      <template v-if="$route.name === 'AddCoupon' || $route.name === 'AddPaymentCoupon'">
        <div class="coupon-overview-wrapper app--hidden app--mobile-shown">
          <div class="overview-wrapper">
            <div class="overview">
              <div class="right">
                <BaseButton @click="$router.push(backUrl)" variant="none" class="mobile-btn"
                  >取消</BaseButton
                >
              </div>
            </div>
            <div class="overview">
              <div class="right">
                <BaseButton
                  @click="$emit('save-draft-click')"
                  variant="none"
                  class="mobile-btn mobile-btn-green"
                >
                  儲存草稿
                </BaseButton>
              </div>
            </div>
            <div class="overview">
              <div class="right">
                <ButtonPreview
                  @click="$emit('preview-click')"
                  :isShowIcon="true"
                  class="mobile-btn"
                  variant="none"
                >
                  預覽及提交
                </ButtonPreview>
              </div>
            </div>
          </div>
        </div>
      </template>
      <template v-else>
        <template v-if="isPermit('EDIT')">
          <template v-if="readOnly">
            <div class="coupon-overview-wrapper app--hidden app--mobile-shown">
              <div class="overview-wrapper">
                <div class="overview">
                  <div class="right">
                    <ButtonEdit @click="onEdit" class="mobile-btn mobile-btn-blue" variant="none">
                      編輯
                    </ButtonEdit>
                  </div>
                </div>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="coupon-overview-wrapper app--hidden app--mobile-shown">
              <div class="overview-wrapper">
                <div class="overview">
                  <div class="right">
                    <BaseButton variant="none" @click="onCancel" class="mobile-btn">
                      <template>
                        <b-icon-x scale="1.5"></b-icon-x>
                      </template>
                      取消
                    </BaseButton>
                  </div>
                </div>
                <div class="overview" v-if="isPermit('REMOVE')">
                  <div class="right">
                    <ButtonRemove
                      @click="prepareAction('REMOVE')"
                      variant="none"
                      class="mobile-btn mobile-btn-red"
                    >
                      移除草稿
                    </ButtonRemove>
                  </div>
                </div>
                <div class="overview" v-if="isPermit('SAVE')">
                  <div class="right">
                    <BaseButton
                      @click="$emit('save-draft-click')"
                      variant="none"
                      class="mobile-btn mobile-btn-green"
                    >
                      <template>
                        <b-icon-file-earmark-text></b-icon-file-earmark-text>
                      </template>
                      儲存草稿
                    </BaseButton>
                  </div>
                </div>
                <div class="overview">
                  <div class="right">
                    <ButtonPreview
                      @click="$emit('preview-click')"
                      :isShowIcon="true"
                      class="mobile-btn"
                      variant="none"
                    >
                      預覽及提交
                    </ButtonPreview>
                  </div>
                </div>
              </div>
            </div>
          </template>
        </template>
        <template v-else>
          <div class="coupon-overview-wrapper app--hidden app--mobile-shown">
            <div class="overview-wrapper">
              <div class="overview" v-if="isPermit('STOPPED')">
                <div class="right">
                  <ButtonUnpublish
                    @click="prepareAction('UNPUBLISH', '你已暫停發佈這個優惠')"
                    variant="none"
                    class="mobile-btn mobile-btn-red"
                  >
                    暫停發佈
                  </ButtonUnpublish>
                </div>
              </div>
              <div class="overview" v-if="isPermit('REDEMPTION_STATUS')">
                <div class="right">
                  <ButtonRedemptionStatus
                    @click="stocksModal = true"
                    class="mobile-btn"
                    variant="none"
                  >
                    兌換情況
                  </ButtonRedemptionStatus>
                </div>
              </div>
              <div class="overview" v-if="isPermit('CANCEL')">
                <div class="right">
                  <BaseButton @click="prepareAction('CANCEL')" variant="none" class="mobile-btn">
                    <template>
                      <b-icon-x scale="1.5"></b-icon-x>
                    </template>
                    取消提交
                  </BaseButton>
                </div>
              </div>
              <div class="overview">
                <div class="right">
                  <ButtonPreview
                    v-if="readOnly"
                    @click="$bvModal.show('coupon-preview-modal')"
                    class="mobile-btn"
                    variant="none"
                  >
                    預覽
                  </ButtonPreview>
                </div>
              </div>
            </div>
          </div>
        </template>
      </template>
      <!-- button-for-mobile end -->
    </template>

    <CouponStocksModal
      v-model="stocksModal"
      :id="inputVal.reward.id"
      :isShowStockQuantity="true"
      :isShowSubMerchantCol="isShowSubMerchantCol"
      :couponType="this.inputVal.couponMeta.codeType"
    ></CouponStocksModal>
    <BaseModal
      @ok-click="modal.okAction"
      :title="modal.title"
      :is-open="modal.isShow"
      @cancel-click="modal.cancelAction"
      @hidden="modal.isShow = false"
      :size="modal.action === 'UNPUBLISH' ? 'md' : 'sm'"
      :okTitle="translatedAction"
      :okVariant="actionButtonVariant"
    >
      <NotificationMessage variant="none" v-if="modal.action === 'UNPUBLISH'">
        請留意：仍需提供優惠給予已兌換優惠之會員。
      </NotificationMessage>
    </BaseModal>
  </BaseControlBar>
</template>

<script>
import { mapGetters } from 'vuex';
import controlBarMixin from '@/mixins/control-bar';
import BaseControlBar from '@/components/BaseControlBar.vue';
import BaseModal from '@/components/BaseActionModal.vue';
import { tap, switchMap } from 'rxjs/operators';
import store, { SET_LOADING } from '@/store';
import cloneDeep from 'lodash.clonedeep';
import { BIconX, BIconFileEarmarkText } from 'bootstrap-vue';
import NotificationMessage from '@/components/NotificationMessage.vue';
import http from '../../helpers/http';

export default {
  mixins: [controlBarMixin],
  components: {
    BaseControlBar,
    BaseModal,
    BIconX,
    BIconFileEarmarkText,
    NotificationMessage,
  },
  data: () => ({
    stocksModal: false,
    modal: {
      title: '',
      isShow: false,
      okAction() {},
      cancelAction() {},
    },
    availableActions: {
      PENDING: ['PREVIEW', 'CANCEL'],
      SCHEDULED: ['PREVIEW', 'STOPPED'],
      PUBLISHED: ['PREVIEW', 'REDEMPTION_STATUS', 'STOPPED'],
      STOPPED: ['PREVIEW', 'REDEMPTION_STATUS'],
      EXPIRED: ['PREVIEW', 'REDEMPTION_STATUS'],
      REJECTED: ['EDIT', 'PREVIEW'],
      REMOVED: ['PREVIEW'],
      DRAFT: ['EDIT', 'SAVE', 'REMOVE'],
    },
  }),
  computed: {
    ...mapGetters(['role']),
    currentStatus() {
      return this.inputVal.currentStatus?.status;
    },
    backUrl() {
      return `/${this.$route.path.split('/')[1]}`;
    },
    translatedAction() {
      switch (this.modal.action) {
        case 'UNPUBLISH':
          return '暫停發佈';
        default:
          return '確定';
      }
    },
    actionButtonVariant() {
      switch (this.modal.action) {
        case 'UNPUBLISH':
          return 'danger';
        default:
          return 'success';
      }
    },
    isShowSubMerchantCol() {
      if (this.inputVal.couponMeta.codeType === 'mc-qr') {
        return true;
      }
      return false;
    },
  },
  methods: {
    prepareAction(action) {
      let title = '';
      switch (action) {
        case 'REMOVE':
          title = '確定移除草稿？';
          break;
        case 'CANCEL':
          title = '確定取消提交？';
          break;
        case 'UNPUBLISH':
          title = '確定暫停發佈此優惠券？';
          break;
        default:
      }
      this.modal = {
        isShow: true,
        action,
        title,
        okAction: () => {
          this.onCouponStatusUpdate$.next();
        },
        cancelAction: () => {
          this.modal.isShow = false;
        },
      };
    },
  },
  domStreams: ['onCouponStatusUpdate$'],
  subscriptions() {
    return {
      couponStatusUpdate: this.onCouponStatusUpdate$.pipe(
        tap(() => {
          store.commit(SET_LOADING, true);
        }),
        switchMap(() => {
          const { action } = this.modal;
          return http(
            {
              method: 'POST',
              url: `/agc-${this.role}-api/coupons/${action.toLowerCase()}`,
              data: {
                rewardId: this.inputVal.reward.id,
              },
            },
            {
              next: (res) => {
                this.inputVal = cloneDeep(res);
                this.$nextTick(() => {
                  if (res.reward.status === 'REMOVED') {
                    this.$router.push(this.backUrl);
                  } else {
                    this.$emit('update:couponStateBeforeUpdate', cloneDeep(res));
                  }
                });
              },
              complete: () => {
                this.modal.isShow = false;
                store.commit(SET_LOADING, false);
              },
            },
          );
        }),
      ),
    };
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables";
.btn-outline-none:hover {
  background: rgba(0, 132, 255, 0.2);
}

@include respond(tab-landscape) {
  .mobile-border {
    width: 100%;
    justify-content: space-between;
  }

  .app--mobile-shown {
    display: block !important;
  }

  .app--mobile-hidden {
    display: none !important;
  }

  .mobile-btn-blue {
    color: #3596f4 !important;
  }

  .mobile-btn-green {
    color: green !important;
  }

  .mobile-btn-red {
    color: red !important;
  }
}

.coupon-overview-wrapper {
  background-color: #fff;
  width: 100%;
  display: inline-block;
  color: #fff;
  position: relative;
  margin-bottom: 10px;

  .overview-wrapper {
    width: 100%;
    display: flex;
    justify-content: space-between;

    .overview {
      width: 100%;
      color: #000;
      display: flex;
      justify-content: space-between;
      box-sizing: border-box;

      .left {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        flex-direction: column;
        align-content: space-between;
      }
      .right {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        border-right: 1px solid #ccc;
      }
    }

    .overview:last-child {
      .right {
        border: 0px;
      }
    }

    .mobile-btn {
      flex-direction: column;
      background: none;
      border: none;
      color: gray;
    }
  }
}
</style>
